<template>
    <div class="container">
        <div class="backButton">
            <v-icon class="material-icons-round" @click="goBack"> arrow_back </v-icon>
        </div>
        <WithdrawalCancelDialog v-if="showDialog" :showDialog="showDialog" @closeDialog="closeDialog" @cancelWithdrawal="cancelWithdrawal"/>
        <div v-if="step == 1">
            <div class="heading" >
                History
            </div>
            <div v-for="(portfolio, index) in portfolios" :key="index" >
                <PortfolioCard :portfolio="portfolio" screen="active" @showActiveWithdrawalDetails="showWithdrawalDetails(portfolio)" @showCancelDialog="showCancelDialog"/>
            </div>
        </div>
        <div v-else-if="step == 2">
            <ActiveWithdrawalDetails :selectedWithdrawal="selectedWithdrawal"/>
        </div>

        <v-snackbar
            v-model="snackbar"
            app
            timeout="5"
        >
                {{failureText}}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import PortfolioCard from '@/components/withdrawal/portfolioCard.vue'
import ActiveWithdrawalDetails from '@/components/withdrawal/activeWithdrawalDetails.vue'
import LenderService from '@/services/lenderService'
import WithdrawalCancelDialog from './withdrawalCancelDialog.vue'
export default {
    name: 'ActiveWithdrawals',
    components: {
        PortfolioCard,
        ActiveWithdrawalDetails,
        WithdrawalCancelDialog
    },
    data () {
        return {
            step: 1,
            selectedWithdrawal: null,
            portfolios: null,
            showDialog: false,
            snackbar: false,
            failureText: 'Failed to cancel withdrawal request!'
        }
    },
    mounted () {
        this.getPendingWithdrawals()
    },
    methods: {
        async getPendingWithdrawals () {
            this.$store.commit('isLoading', { message: 'We are calculating your withdrawal amount!' })
            const response = await LenderService.getPendingWithdrawals()
            this.portfolios = response.data.result
            this.$store.commit('isNotLoading')
        },
        showWithdrawalDetails (withdrawal) {
            this.selectedWithdrawal = withdrawal
            this.step = 2
        },
        goBack () {
            if (this.step === 1) {
                this.$emit('goBack')
            } else {
                this.step--
            }
        },
        showCancelDialog (withdrawal) {
            this.selectedWithdrawal = withdrawal
            this.showDialog = true
        },
        closeDialog () {
            this.showDialog = false
        },
        async cancelWithdrawal () {
            console.log('cancelling the withdrawal request!')
            this.$store.commit('isLoading', { message: 'Canceling your withdrawal request!' })
            const payload = {
                reassignmentId: this.selectedWithdrawal.reassignmentId
            }
            const response = await LenderService.cancelWithdrawalRequest(payload)
            if (response.status !== 200) {
                this.snackbar = true
                this.$store.commit('isNotLoading')
            } else {
                await this.getPendingWithdrawals()
            }
            this.showDialog = false
        }
    }
}
</script>

<style scoped>

    @media (min-width: 990px) {
        .backButton {
            position: absolute;
            left: -30px;
            top: 24px;
        }
    }

    .backButton {
        width: 100%;
    }

    .heading {
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #232323;
        margin-bottom: 26px;
        margin-top: 12px;
    }
</style>
